import React from "react";
import { AdministrateSelect, AdminOptionableSelect } from "./AdministrateSelect";

export const AdministrateEnumFilter = ({ options, column: { filterValue, setFilter }, SelectComponent = AdministrateSelect, ...rest }) => {
  return (
    <SelectComponent
      onChange={setFilter}
      value={filterValue}
      menuPortalTarget={document.body}
      styles={{
        option: (provided, state) => ({
          ...provided,
          textAlign: "left",
        }),
      }}
      className="me-2"
      {...rest}
    />
  );
};

export const AdminOptionableFilter = ({ resource, ...rest }) => (
  <AdministrateEnumFilter {...rest} SelectComponent={AdminOptionableSelect} resource={resource} />
);
